export { default as Exhibition } from "./main";

import routes from "./routes";
import * as Anchors from "./anchors";
export default {
  Anchors,
  routes,
};
